export default __webpack_public_path__ + "static/media/no-marbles2.dd5e2dc2.gif";